const shadows = ['none', '0px 0px 10px rgba(0,0,0,0.25)'];

export default shadows;
